import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { SiSap, SiQuickbooks, SiGooglesheets, SiZoom, SiGmail, SiNotion, SiJira, SiZapier } from 'react-icons/si';
import { Container, fadeInUp } from './shared';

type IconComponent = React.ComponentType<{ className?: string }>;

const LOGOS: { Icon: IconComponent; name: string }[] = [
  { Icon: SiSap as IconComponent, name: 'SAP' },
  { Icon: SiQuickbooks as IconComponent, name: 'QuickBooks' },
  { Icon: SiGooglesheets as IconComponent, name: 'Google Sheets' },
  { Icon: SiZoom as IconComponent, name: 'Zoom' },
  { Icon: SiGmail as IconComponent, name: 'Gmail' },
  { Icon: SiNotion as IconComponent, name: 'Notion' },
  { Icon: SiJira as IconComponent, name: 'Jira' },
  { Icon: SiZapier as IconComponent, name: 'Zapier' },
];

const IntegrationsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 sm:py-24">
      <Container>
        <motion.p
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.6 }}
          className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-brand-muted"
        >
          {t('landing.integrations.title')}
        </motion.p>

        <motion.div
          variants={fadeInUp}
          custom={1}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4 lg:grid-cols-8"
        >
          {LOGOS.map(({ Icon, name }) => (
            <div
              key={name}
              title={name}
              className="glass-card flex h-20 items-center justify-center rounded-2xl grayscale opacity-60 transition-all duration-300 hover:opacity-100 hover:grayscale-0"
            >
              <Icon className="h-8 w-8 text-white" />
            </div>
          ))}
        </motion.div>
      </Container>
    </section>
  );
};

export default IntegrationsSection;
